// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"49":"211a1182","987":"329bffe2"}[chunkId] + ".js";
};